import React from 'react';
import Services from '../components/Services';
import PageSeo from '../components/shared/PageSeo';
import { PAGE_SEO } from '../data/seo';

const ServicesPage = () => (
  <>
    <PageSeo {...PAGE_SEO.services} />
    <Services />
  </>
);

export default ServicesPage;
